<template>
  <div class="profile-connect">
    <div v-if="platform === 'steam'" class="profile-connect__connect">
      <header-text
        :label="$t('connect_account')"
        :title="$t('link_to_steam')"
      ></header-text>

      <div class="description">
        <p>
          {{ $t("account_link_description_1") }}
        </p>
        <p>
          {{ $t("account_link_description_2") }}
        </p>
      </div>

      <div class="platforms">
        <a
          v-if="platform === 'steam'"
          href="#"
          class="platform"
          @click.prevent="platformClick('steam')"
        >
          <div class="platform__icon"><iconSteam /></div>
          <span class="platform__button">{{ $t("connect") }}</span>
        </a>
      </div>
    </div>

    <div v-else-if="platform === 'galaxy'" class="profile-connect__connect">
      <header-text
        :label="$t('connect_account')"
        :title="$t('link_to_gog')"
      ></header-text>

      <div class="description">
        <p>
          {{ $t("account_link_description_1") }}
        </p>
        <p>
          {{ $t("account_link_description_2") }}
        </p>
      </div>

      <div class="platforms">
        <a href="#" class="platform" @click.prevent="platformClick('galaxy')">
          <div class="platform__icon"><iconGalaxy /></div>
          <span class="platform__button">{{ $t("connect") }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

import iconSteam from "@/components/Icons/iconSteam";
import iconGalaxy from "@/components/Icons/iconGalaxy";

export default {
  components: {
    iconSteam,
    iconGalaxy
  },
  props: {
    platform: {
      type: String
    }
  },

  data() {
    return {
      modalType: false,
      gamePlatforms: {
        steam: {
          name: "Steam"
        }
      }
    };
  },

  validations: {
    email: {
      required,
      email
    }
  },
  methods: {
    platformClick(key) {
      this.$emit("connect", key);
    }
  }
};
</script>

<style lang="scss" scoped>
.platforms {
  display: flex;
  height: 100%;

  justify-content: center;
  // padding-bottom: 60px;
}

.platform {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: $yellow;

  &:first-child {
    border-right: 1px solid #d9be69;
  }

  &__icon {
    padding: 40px;
    pointer-events: none;
  }

  &__button {
    width: 100%;
    font-family: "Gilam SemiBold";
    font-size: 15px;
    text-transform: uppercase;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #d9be69;
    border-bottom: 1px solid #d9be69;
    pointer-events: none;
  }

  svg {
    max-width: 100%;
    height: auto;
    opacity: 0.6;
    transition: opacity 300ms ease;
  }

  &:first-child {
    padding-left: 0;
  }

  &:hover {
    svg {
      opacity: 1;
    }
  }
}

.platform--active {
  .platform__button {
    background-color: #272727;
    color: $white;

    svg {
      margin-left: 10px;
    }
  }
}

.description {
  margin-bottom: 40px;

  p {
    color: $white-60;
    text-align: center;
  }
}

.profile-connect__connected {
  .platform {
    width: 100%;
    border: 2px solid $green-darker;
    background: $green-darker-25;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 45px 60px 60px 60px;

    &__description {
      color: $white;
      text-align: center;
      margin: 25px 0 0 0;
    }
  }
}

@media screen and (min-width: $screen-sm) {
  .platforms {
    height: auto;
    &__item {
      padding: 4rem;
    }
  }

  .platform {
    width: 50%;

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 30px;
      // min-height: 140px;
    }
  }
}

@media screen and (min-width: $screen-md) {
  .platform {
    &__icon {
      // min-height: 150px;
    }
  }
}

@media screen and (min-width: $screen-lg) {
  .platforms {
    // padding-bottom: 100px;
  }

  .platform {
    &__icon {
      // min-height: 180px;
    }
  }
}
</style>
